export const formatRut = (value) => {
  let clean = value.replace(/[^0-9kK]/g, '').toUpperCase();
  const firstKIndex = clean.indexOf('K');
  if (firstKIndex !== -1) {
    clean =
      clean.slice(0, firstKIndex + 1) +
      clean.slice(firstKIndex + 1).replace(/K/g, '');
  }
  const cuerpo = clean.slice(0, -1);
  const dv = clean.slice(-1);
  const cuerpoLimitado = cuerpo.slice(0, 8);
  if (cuerpoLimitado.length === 0) return dv;
  let cuerpoConFormato = '';
  let i = 0;
  for (let j = cuerpoLimitado.length - 1; j >= 0; j--) {
    cuerpoConFormato = cuerpoLimitado[j] + cuerpoConFormato;
    i++;
    if (i % 3 === 0 && j !== 0) {
      cuerpoConFormato = '.' + cuerpoConFormato;
    }
  }

  return `${cuerpoConFormato}-${dv}`;
};
